import { Box, Divider, Grid, Paper, Stack } from "@mui/material";
import EncounterProvider from "./encounter.provider";
import PatientInfo from "./components/patientInfo";
import DiagnosisInfo from "./components/diagnosisInfo";
import SimpleBar from "simplebar-react";
import AbsoluteSavePanel from "./components/absoluteSavePanel";
import UtilityBox from "./components/utilityBox";
import FavoriteProvider from "./favorite.provider";

const Encounter = () => {
    return (
        <EncounterProvider>
            <FavoriteProvider>
                <Box
                    padding={1}
                    width="100%"
                    component={Paper}
                    sx={{
                        height: "calc(100%)",
                        maxHeight: "calc(100%)"
                    }}
                    variant="outlined"
                >
                    <Box
                        component={SimpleBar}
                        sx={{ height: "calc(100% - 52px)" }}
                    >
                        <Stack height="100%" spacing={1}>
                            {/* <Typography sx={{ fontWeight: 500 }}>
                                Encounter Info
                            </Typography>
                            <Divider /> */}
                            <PatientInfo />
                            <Divider />
                            <Box>
                                <Grid container spacing={1}>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        sx={{
                                            borderColor: (theme) =>
                                                theme.palette.divider,
                                            borderRightStyle: "solid",
                                            borderRightWidth: 1
                                        }}
                                    >
                                        <DiagnosisInfo />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <UtilityBox />
                                    </Grid>
                                </Grid>
                            </Box>
                        </Stack>
                    </Box>
                    <AbsoluteSavePanel />
                </Box>
            </FavoriteProvider>
        </EncounterProvider>
    );
};

export default Encounter;
